import { ChangeEvent } from 'react';
import { RadioButtonProps } from '@msc-b2c/interfaces/types';
import '@msc-b2c/base-style/src/lib/site/base-style/base-components/_radio-checkbox.scss';

import { sanitize } from '@msc-b2c/shared-utils';
import { keyCodes } from '@msc-b2c/shared-utils/keyboardUtils';

export const RadioButton = ({
  id,
  name,
  text,
  value,
  checked,
  disabled = false,
  styleOptions,
  onChange,
  ariaLabel,
  tabIndex,
  ariaDescribedBy,
}: RadioButtonProps) => {
  return (
    <div className={`options react-options ${styleOptions}`}>
      <div className="cmp-form-options--radio">
        <label
          className="cmp-form-options__field-label"
          htmlFor={id}
        >
          <input
            type="radio"
            id={id}
            name={name}
            value={value}
            checked={checked}
            disabled={disabled}
            onChange={onChange}
            onKeyDown={(event) => {
              if (!disabled && event.key === keyCodes.ENTER) {
                event.preventDefault();
                onChange(event as unknown as ChangeEvent<HTMLInputElement>);
              }
            }}
            aria-label={ariaLabel}
            tabIndex={tabIndex ?? 0}
            aria-checked={checked}
            aria-describedby={ariaDescribedBy}
          />
          {text && (
            <span
              dangerouslySetInnerHTML={{ __html: sanitize(text) }}
              className="cmp-form-options__field-description"
            ></span>
          )}
        </label>
      </div>
    </div>
  );
};
